import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { FilterChipsAlign } from './FilterChips.types';

interface StChipScrollContainerProps {
  align?: FilterChipsAlign;
}

export const StChipScrollContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'align',
})<StChipScrollContainerProps>(({ theme, align = 'center' }) => ({
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-start',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  flexWrap: 'wrap',
  marginTop: '24px',
  marginBottom: align === 'start' ? '40px' : '16px',
  marginLeft: 0,
  marginRight: 0,
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    ...(align === 'start' && {
      marginTop: '32px',
      marginBottom: '56px',
    }),
  },
  [theme.breakpoints.up('md')]: {
    justifyContent: align === 'start' ? 'flex-start' : 'center',
    overflowX: 'visible',
    ...(align === 'start' && {
      marginTop: '48px',
      marginBottom: '44px',
    }),
  },
  [theme.breakpoints.up('lg')]: {
    gap: '12px',
    fontWeight: 500,
  },
}));

interface StChipButtonProps {
  active?: boolean;
}

export const StChipButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<StChipButtonProps>(({ theme, active }) => ({
  flexShrink: 0,
  borderRadius: '9999px',
  border: `1px solid ${
    active ? theme.palette.primary.main : theme.palette.neutral4?.main || '#D9D9D9'
  }`,
  backgroundColor: active ? theme.palette.primary.main : theme.palette.white.main,
  color: active ? theme.palette.white.main : theme.palette.neutral7?.main || '#64748B',
  padding: '8px 12px',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: 1.4,
  cursor: 'pointer',
  textTransform: 'none',
  fontFamily: `${theme.palette.primaryFontFamilyType}, sans-serif`,
  whiteSpace: 'nowrap',
  outline: 'none',
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '2px',
  },
  [theme.breakpoints.up(500)]: {
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: 600,
  },
  '&:hover': {
    backgroundColor: active ? theme.palette.primary.main : theme.palette.white.main,
    color: active ? theme.palette.white.main : theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));
